import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.warn('[Slava Health] Supabase env vars missing — добавь VITE_SUPABASE_URL и VITE_SUPABASE_ANON_KEY в .env');
}

// Ответы API нельзя брать из HTTP-кэша (05.10.2026, боевой случай в чате).
// Сервер отдаёт их без Cache-Control. Когда человек уходит из телеграма минут
// на двадцать, iOS выгружает страницу, а при возврате восстанавливает её в режиме
// «бери из кэша что есть» — и GET-запрос истории чата получал ответ, сохранённый
// при прошлом открытии. База цела, а экран показывал переписку двухдневной
// давности, и Дофи «не помнил» свежий разговор. То же грозит дневнику и любому
// другому чтению, поэтому запрет стоит здесь, на всех запросах разом.
const noStoreFetch: typeof fetch = (input, init) =>
  fetch(input, { ...init, cache: 'no-store' });

export const supabase = createClient(url!, anonKey!, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'slava-health-auth',
    debug: false,
  },
  global: {
    fetch: noStoreFetch,
    headers: {
      'x-application-name': 'slava-health',
    },
  },
});

// 🆕 Слушаем события auth для лучшей отладки и восстановления
if (typeof window !== 'undefined') {
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'TOKEN_REFRESHED') {
      console.log('[Auth] Token refreshed successfully');
    }
    if (event === 'SIGNED_OUT') {
      console.log('[Auth] User signed out');
    }
    if (event === 'USER_UPDATED') {
      console.log('[Auth] User updated');
    }
  });
  
  // 🆕 Восстановление сессии при возврате в приложение
  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'visible') {
      // Когда юзер возвращается в приложение — проверяем сессию
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) {
        console.error('[Auth] Session check error on visibility:', error);
      } else if (session) {
        // Проверяем не истёк ли токен
        const expiresAt = session.expires_at ? session.expires_at * 1000 : 0;
        const now = Date.now();
        const timeUntilExpiry = expiresAt - now;
        
        // Если до истечения осталось < 5 минут — обновляем заранее
        if (timeUntilExpiry > 0 && timeUntilExpiry < 5 * 60 * 1000) {
          console.log('[Auth] Token expires soon, refreshing...');
          await supabase.auth.refreshSession();
        }
      }
    }
  });
}
